/**
 * If the page was opened with `?desktop=1&state=...&challenge=...` (Tauri
 * desktop app sign-in flow), build a full-nav URL to /api/desktop-auth/issue.
 * Otherwise return the fallback in-app route.
 *
 * Caller must use `window.location.href = target` (not router.push) when the
 * returned URL starts with /api/ — the browser needs to follow the API's 302
 * to `snaptransfer://auth?...` for the OS to launch the desktop app.
 */
export function desktopRedirectOrFallback(searchParams: URLSearchParams, fallback: string): string {
  if (searchParams.get('desktop') !== '1') return fallback
  const state = searchParams.get('state')
  const challenge = searchParams.get('challenge')
  if (!state || !challenge) return fallback
  return `/api/desktop-auth/issue?state=${encodeURIComponent(state)}&challenge=${encodeURIComponent(challenge)}`
}
